export enum DossierSearchKey {
  Labels = 'labels',
  RecentActivity = 'recentActivity',
  DossierSearch = 'dossierSearch',
  Filters = 'filters',
  QuickSearch = 'quickSearch',
  Dashboard = 'dashboard'
}
